// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"262":"282f65815c8826c8","956":"5d2aab12b8990f07"}[chunkId] + ".js";
};